import * as React from "react";
import { cn } from "@/utils/cn";
export interface RoomDetailSkeletonProps {
  className?: string;
}

export const RoomDetailSkeleton = React.forwardRef<
  HTMLDivElement,
  RoomDetailSkeletonProps
>(({ className }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "rounded-2xl",
        "p-6 md:p-8 lg:p-10",
        "space-y-8 md:space-y-10",
        className,
      )}
    >
      <div className="h-10 w-50 animate-pulse rounded-md bg-neutral-700" />

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-12">
        <div className="flex flex-col gap-2">
          <div className="h-8 w-32 animate-pulse rounded bg-neutral-700" />
          <div className="h-8 w-40 animate-pulse rounded bg-neutral-600" />
        </div>
        <div className="flex flex-col gap-2">
          <div className="h-8 w-40 animate-pulse rounded bg-neutral-700" />
          <div className="h-8 w-16 animate-pulse rounded bg-neutral-600" />
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <div className="h-8 w-32 animate-pulse rounded bg-neutral-700" />

        <div className="h-8 w-40 animate-pulse rounded-full bg-neutral-600 md:hidden" />
        <div className="hidden flex-wrap gap-2 md:flex">
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={i}
              className="h-8 w-20 animate-pulse rounded-full bg-neutral-600"
            />
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <div className="h-8 w-40 animate-pulse rounded bg-neutral-700" />

        <div className="max-w-4xl space-y-2">
          <div className="h-8 w-full animate-pulse rounded bg-neutral-600" />
          <div className="h-8 w-11/12 animate-pulse rounded bg-neutral-600" />
          <div className="h-8 w-10/12 animate-pulse rounded bg-neutral-600" />
        </div>
      </div>
    </div>
  );
});

RoomDetailSkeleton.displayName = "RoomDetailSkeleton";
